import A11yDialog from 'a11y-dialog';
import { hideOthers, inertOthers, supportsInert } from 'aria-hidden';

/**
* @constructor
* Implements study controller
*
* @param {Element} container The modal element.
*/
export default function StudyRegister( container ) {

	let dialog = "";
	const study_buttons = document.querySelectorAll( '.js-open-identification' );
	let registered = false;

	this.init = () => {

		dialog = new A11yDialog( container );

		study_buttons.forEach( ( elt ) => {
			elt.addEventListener( 'click', ( e ) => {
				e.stopImmediatePropagation();
				e.preventDefault();

				dialog.show();
			} );
		} );

		dialog.on( 'show', function () {

			let focusOnElement = "";
			if ( supportsInert() ) {
				focusOnElement = inertOthers( container );
			} else {
				focusOnElement = hideOthers( container );
			}

			if ( !registered ) {
				dialog.on( 'hide', focusOnElement );
				registered = true
			}

			if ( container.querySelector( '.dialog__status' ) != null ) {
				container.querySelector( '.dialog__status' ).focus();
			}

			if ( container.dataset.status != 1 ) {
				return false;
			}

		} );

	}

}